import { faCircleExclamation, faFile, faUpload, faX } from '@fortawesome/sharp-solid-svg-icons';
import { getDataTestId } from 'eone-ui/functions/data-test-ids';
import { FontAwesome } from 'eone-ui/icons/icons';
import React, { useRef } from 'react';
import './styles.css';
//import { useState } from '@storybook/preview-api';

function FileUploaderError(props) {
  return <label style={{ paddingTop: 8 }}>{props.Error}</label>;
}

function FileUploaderArea(props) {
  const selectFile = () => {
    if (typeof props.SelectFile === 'function') {
      props.SelectFile();
    }
  };

  const getErrors = () => {
    return props.Errors.map((error, index) => {
      return <FileUploaderError key={index} Error={error} />;
    });
  };

  if (props.Loading) {
    return <label>{props.LoadingMessage || 'Loading...'}</label>;
  }

  if (props.Errors && props.Errors.length > 0) {
    return (
      <React.Fragment>
        <FontAwesome Icon={props.ErrorIcon || faCircleExclamation} Size="2x" />
        <div className="eone-ui-file-uploader-message">{getErrors()}</div>
        <a
          onClick={selectFile}
          className="eone-ui-file-uploader-prompt"
          data-testid={props.SelectFileDataTestId}
        >
          Change file
        </a>
      </React.Fragment>
    );
  }

  //if (props.File) {
  //	return (
  //		<div className="eone-ui-file-uploader-inner-container">
  //			<FontAwesome Icon={props.FileIcon || faFile} Size="2x" />
  //			<label className="eone-ui-file-uploader-message">{props.File}</label>
  //			<a onClick={selectFile} className="eone-ui-file-uploader-prompt">
  //				Replace file
  //			</a>
  //		</div>
  //	);
  //}

  //if (props.Message) {
  //	if (props.Prompt) {
  //		return (
  //			<div className="eone-ui-file-uploader-area-inner-container">
  //				<div className="eone-ui-file-uploader-icon">
  //					<FontAwesome Icon={props.Icon || faUpload} Size="2x" />
  //				</div>
  //				<div>
  //					<label className="eone-ui-file-uploader-message">{props.Message} </label>
  //					<a onClick={selectFile} className="eone-ui-file-uploader-prompt">
  //						{props.Prompt}
  //					</a>
  //				</div>
  //				<label className="eone-ui-file-uploader-sub-message">{props.SubMessage} </label>
  //			</div>
  //		);
  //	}
  //	return (
  //		<div className="eone-ui-file-uploader-inner-container">
  //			<a onClick={selectFile} className="eone-ui-file-uploader-icon">
  //				<FontAwesome Icon={props.Icon || faUpload} Size="2x" />
  //			</a>
  //			<label className="eone-ui-file-uploader-message">{props.Message}</label>
  //		</div>
  //	);
  //}

  return (
    <div className="eone-ui-file-uploader-area-inner-container">
      <div className="eone-ui-file-uploader-icon">
        <FontAwesome Icon={props.Icon || faUpload} Size="2x" />
      </div>
      <div>
        <label className="eone-ui-file-uploader-message">{props.Message} </label>
        <a
          onClick={selectFile}
          className="eone-ui-file-uploader-prompt"
          data-testid={props.SelectFileDataTestId}
        >
          {props.Prompt}
        </a>
      </div>
      <label className="eone-ui-file-uploader-sub-message">{props.SubMessage} </label>
    </div>
  );
}

function FileUploaderButton(props) {
  const selectFile = () => {
    if (typeof props.SelectFile === 'function') {
      props.SelectFile();
    }
  };

  const getErrors = () => {
    return props.Errors.map((error, index) => {
      return <FileUploaderError key={index} Error={error} />;
    });
  };

  if (props.Loading) {
    return <label>{props.LoadingMessage || 'Loading...'}</label>;
  }

  if (props.Errors && props.Errors.length > 0) {
    return (
      <React.Fragment>
        <FontAwesome Icon={props.ErrorIcon || faCircleExclamation} Size="sm" />
        <div className="eone-ui-file-uploader-message">{getErrors()}</div>
        <a
          onClick={selectFile}
          className="eone-ui-file-uploader-prompt"
          data-testid={props.SelectFileDataTestId}
        >
          Change file
        </a>
      </React.Fragment>
    );
  }

  if (props.File) {
    return (
      <div className="eone-ui-file-uploader-inner-container">
        <FontAwesome Icon={props.FileIcon || faFile} Size="sm" />
        <label className="eone-ui-file-uploader-message">{props.File}</label>
        <a
          onClick={selectFile}
          className="eone-ui-file-uploader-prompt"
          data-testid={props.SelectFileDataTestId}
        >
          Replace file
        </a>
      </div>
    );
  }

  if (props.Message) {
    if (props.Prompt) {
      return (
        <div className="eone-ui-file-uploader-inner-container">
          <FontAwesome Icon={props.Icon || faUpload} Size="sm" />
          <div>
            <label className="eone-ui-file-uploader-message">
              {props.Message}{' '}
              <a
                onClick={selectFile}
                className="eone-ui-file-uploader-prompt"
                data-testid={props.SelectFileDataTestId}
              >
                {props.Prompt}
              </a>
            </label>
          </div>
        </div>
      );
    }
    return (
      <div className="eone-ui-file-uploader-inner-container">
        <a onClick={selectFile} data-testid={props.SelectFileDataTestId}>
          <FontAwesome Icon={props.Icon || faUpload} Size="sm" />
        </a>
        <label className="eone-ui-file-uploader-message">{props.Message}</label>
      </div>
    );
  }

  return (
    <a onClick={selectFile} className="">
      <FontAwesome Icon={props.Icon || faUpload} Size="sm" />
    </a>
  );
}

interface SCFileUploaderProps {
  Icon: any;
  Message: string;
  SubMessage?: string;
  Prompt: string;
  File?: string;
  Loading?: boolean;
  LoadingMessage?: string;
  Errors?: boolean;
  Multiple?: boolean;
  Title?: string;
  Visible?: boolean;
  CanSelect?: boolean;
  CanSelectMessage?: string;
  Accept?: string;
  Large?: boolean;
  DataTestId?: string;
  ShowError?: (title: string, description: string) => void;
  ChangeFile?: (file: File) => void;
  ChangeFileMultiple?: (file: FileList) => void;
}

function SCFileUploader(props: SCFileUploaderProps) {
  const [dragActive, setDragActive] = React.useState(false);
  const inputFile = useRef<HTMLInputElement>(null);

  const clearFile = () => {
    if (typeof props.ChangeFile === 'function') {
      props.ChangeFile(null);
    }
  };

  const selectFile = () => {
    if (props.CanSelect != undefined && props.CanSelect == false && props.ShowError) {
      props.ShowError('File upload error', props.CanSelectMessage ?? '');
      return;
    }
    if (inputFile != null && inputFile.current != null) {
      inputFile.current.value = ''; // need to clear the value so selecting a file with the same name triggers the onchange
      inputFile.current.click();
    }
  };

  const changeFile = (file) => {
    if (typeof props.ChangeFile === 'function') {
      props.ChangeFile(file);
    }
  };
  const changeFileMultiple = (files) => {
    if (typeof props.ChangeFileMultiple === 'function') {
      props.ChangeFileMultiple(files);
    }
  };

  const handleFileChange = (e) => {
    if (props?.Multiple ?? false) {
      if (e.target.files && e.target.files.length > 0) {
        console.log('calling changeFileMultiple with ', e.target.files);
        changeFileMultiple(e.target.files);
      }
    } else {
      const fileObj = e.target.files && e.target.files[0];
      if (fileObj) {
        changeFile(e.target.files[0]);
      }
    }
  };

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (props?.Multiple ?? false) {
      changeFileMultiple(e.dataTransfer.files);
    } else if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      changeFile(e.dataTransfer.files[0]);
    }
  };

  const getClassName = () => {
    let className = `eone-ui-file-uploader-container${props.Large ? '-area' : ''}`;
    if (dragActive) {
      className = className + ' eone-ui-file-uploader-container-dragging';
    }
    return className;
  };

  if (props.Visible != undefined && props.Visible == false) return null;

  if (props.Large) {
    return (
      <div
        data-testid={props.DataTestId}
        style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 10 }}
      >
        <div
          className={getClassName()}
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        >
          <FileUploaderArea
            Icon={props.Icon}
            File={props.File ?? ''}
            FileIcon={props.Icon}
            Message={props.Message}
            SubMessage={props.SubMessage}
            Prompt={props.Prompt}
            Errors={props.Errors ?? true}
            ErrorIcon={faX}
            Loading={props.Loading}
            LoadingMessage={props.LoadingMessage}
            SelectFile={selectFile}
            SelectFileDataTestId={getDataTestId(props.DataTestId, 'select-file')}
          />
        </div>
        {props.File && (
          <div className="eone-ui-file-uploader-area-uploaded-file-container">
            <div className="eone-ui-file-uploader-area-tag-container">
              <div className="eone-ui-file-uploader-area-file-icon">
                <FontAwesome Icon={faFile} />
              </div>
              <label className="">{props.File}</label>
            </div>
            <div className="eone-ui-file-uploader-area-tag-container">
              <label className="eone-ui-file-uploader-area-tag-message">Ready</label>
              <div style={{ cursor: 'pointer' }} onClick={() => clearFile()}>
                <FontAwesome Size="xs" Icon={faX} />
              </div>
            </div>
          </div>
        )}

        <input
          type="file"
          id="file"
          ref={inputFile}
          accept={props.Accept}
          multiple={props.Multiple ?? false}
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />
      </div>
    );
  }

  return (
    <React.Fragment>
      <label className="eone-ui-form-label">
        <span>{props.Title}</span>
      </label>
      <div
        className={getClassName()}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
        data-testid={props.DataTestId}
      >
        <FileUploaderButton
          Icon={props.Icon}
          File={props.File ?? ''}
          FileIcon={props.Icon}
          Message={props.Message}
          Prompt={props.Prompt}
          Errors={props.Errors ?? true}
          ErrorIcon={faX}
          Loading={props.Loading}
          LoadingMessage={props.LoadingMessage}
          SelectFile={selectFile}
          SelectFileDataTestId={getDataTestId(props.DataTestId, 'select-file')}
        />

        <input
          type="file"
          id="file"
          ref={inputFile}
          accept={props.Accept}
          multiple={props.Multiple ?? false}
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />
      </div>
    </React.Fragment>
  );
}

export { SCFileUploader };
export type { SCFileUploaderProps };

interface SCFormFieldFileUploaderProps {
  Icon: any;
  Message: string;
  SubMessage?: string;
  Prompt: string;
  File?: string;
  Loading?: boolean;
  LoadingMessage?: string;
  Errors?: boolean;
  Multiple?: boolean;
  Title?: string;
  Visible?: boolean;
  CanSelect?: boolean;
  CanSelectMessage?: string;
  Accept?: string;
  DataTestId?: string;
  Subheading?: string;
  ShowError?: (title: string, description: string) => void;
  ChangeFile?: (file: File) => void;
  ChangeFileMultiple?: (file: FileList) => void;
}

function SCFormFieldFileUploader(props: SCFormFieldFileUploaderProps) {
  const [dragActive, setDragActive] = React.useState(false);
  const inputFile = useRef<HTMLInputElement>(null);

  const selectFile = () => {
    if (props.CanSelect != undefined && props.CanSelect == false && props.ShowError) {
      props.ShowError('File upload error', props.CanSelectMessage ?? '');
      return;
    }
    if (inputFile != null && inputFile.current != null) {
      inputFile.current.value = ''; // need to clear the value so selecting a file with the same name triggers the onchange
      inputFile.current.click();
    }
  };

  const changeFile = (file) => {
    if (typeof props.ChangeFile === 'function') {
      props.ChangeFile(file);
    }
  };
  const changeFileMultiple = (files) => {
    if (typeof props.ChangeFileMultiple === 'function') {
      props.ChangeFileMultiple(files);
    }
  };

  const handleFileChange = (e) => {
    if (props?.Multiple ?? false) {
      if (e.target.files && e.target.files.length > 0) {
        console.log('calling changeFileMultiple with ', e.target.files);
        changeFileMultiple(e.target.files);
      }
    } else {
      const fileObj = e.target.files && e.target.files[0];
      if (fileObj) {
        changeFile(e.target.files[0]);
      }
    }
  };

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (props?.Multiple ?? false) {
      changeFile(e.dataTransfer.files);
    } else if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      changeFile(e.dataTransfer.files[0]);
    }
  };

  const getClassName = () => {
    let className = `eone-ui-file-uploader-container`;
    if (dragActive) {
      className = className + ' eone-ui-file-uploader-container-dragging';
    }
    return className;
  };

  if (props.Visible != undefined && props.Visible == false) return null;

  return (
    <div style={{ marginBottom: 12 }}>
      <div className="eone-ui-form-label-container">
        <label className="eone-ui-form-label">
          <span>{props.Title}</span>
        </label>
      </div>
      <div
        className={getClassName()}
        data-testid={props.DataTestId}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
      >
        <FileUploaderButton
          Icon={props.Icon}
          File={props.File ?? ''}
          FileIcon={props.Icon}
          Message={props.Message}
          Prompt={props.Prompt}
          Errors={props.Errors ?? true}
          ErrorIcon={faX}
          Loading={props.Loading}
          LoadingMessage={props.LoadingMessage}
          SelectFile={selectFile}
          SelectFileDataTestId={
            props.DataTestId ? getDataTestId(props.DataTestId, 'select-file') : undefined
          }
        />

        <input
          type="file"
          id="file"
          ref={inputFile}
          accept={props.Accept}
          multiple={props.Multiple ?? false}
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />
      </div>
      <div className="eone-ui-form-label-sm-container">
        <label className="eone-ui-form-label-sm">
          <span>{props.Subheading}</span>
        </label>
      </div>
    </div>
  );
}

export { SCFormFieldFileUploader };
export type { SCFormFieldFileUploaderProps };
